import Vue from 'vue'
import VueRouter from 'vue-router'
import Cookies from 'js-cookie'
import store from '../store'

import Layout from '@/components/layout/Layout.vue'
import indexLayout from '@/components/layout/IndexLayout.vue'
import homeLayout from '@/components/layout/HomeLayout.vue'

import index from './modules/index'
import home from './modules/home'
// import commodity from './modules/commodity'
import publish from './modules/publish'
import personal from './modules/personal'
import order from './modules/order'
import { record } from '@/util/dataReport.js'

Vue.use(VueRouter)

const routes = [
  // home官网
  {
    path: '/',
    component: homeLayout,
    children: [
      {
        path: '/',
        meta: {
          pageId: 'home'
        },
        component: (resolve) => require(['@/views/home/Home.vue'], resolve)
      },
      ...home
    ]
  },
  // index商城
  {
    path: '/',
    meta: {
      pageId: 'index'
    },
    component: indexLayout,
    children: [
      ...index
      // ...home
    ]
  },
  // 商品，订单，刊登
  {
    path: '/',
    component: Layout,
    children: [...publish, ...personal, ...order]
  }
  // {
  //   path: '/test',
  //   component: (resolve) => require(['@/views/test.vue'], resolve)
  // },
  // {
  //   path: '*',
  //   redirect: '/404'
  // }
]

// 获取原型对象上的push函数
const originalPush = VueRouter.prototype.push
// 修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 全局路由钩子
router.beforeEach((to, from, next) => {
  record({
    pageId: to.meta.pageId,
    prePageId: from.meta.pageId,
    eventType: 'open',
    eventId: `${to.meta.pageId}_open`,
    fullPath: to.fullPath
  })
  const prePageData = {
    path: to.path,
    fullPath: to.fullPath,
    pageId: to.meta.pageId,
    prePageId: from.meta.pageId
  }
  localStorage.setItem('prePageData', JSON.stringify(prePageData))

  // 下单登录流程调整
  // if (to.path !== '/login') {
  //   localStorage.removeItem('loginRedirection')
  // }
  if (to.path === '/confirm-order' && from.path === '/login') {
    localStorage.setItem('confirmOrderLogin', true)
  }

  // if (!localStorage.getItem('reset_login_state')) {
  //   localStorage.setItem('reset_login_state', !JSON.parse(localStorage.getItem('reset_login_state')))
  // }

  // 如果store仓库中的token没有值
  // 并且Cookies中有的情况下
  // 说明用户已经登录了
  // 则把Cookies中的用户信息存储到本地存储中即可
  let cookiesToken = Cookies.get('token')
  let storeToken = store.state.common.token
  if (!storeToken && cookiesToken) {
    let cookies = Cookies.get()
    store.commit('common/set', {
      token: cookies.token,
      userId: cookies.userId,
      userName: cookies.userName,
      email: cookies.email,
      phone: cookies.phone,
      jti: cookies.jti,
      authorities: cookies.authorities
    })
  }

  // 如果store仓库中的token有值
  // 并且cookies中也有值，则判断两个的值是否相等
  // 如果不相等，则把cookies中的值替换掉store中的值
  if (storeToken && cookiesToken) {
    if (storeToken !== cookiesToken) {
      let cookies = Cookies.get()
      store.commit('common/set', {
        token: cookies.token,
        userId: cookies.userId,
        userName: cookies.userName,
        email: cookies.email,
        jti: cookies.jti,
        authorities: cookies.authorities
      })
    }
  }

  window.scroll(0, 0)
  next()
})

export default router
